import React, { useState, useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";
import SubAdminDetail from "../../components/environments/SubAdminDetail";
import SubAdminSearchResult from "../../components/environments/SubAdminSearchResult";
import Header from "../../components/includes/Header";

import {LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//부운영자 관리
const SubAdminInformation = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
      {Header:'번호',accessor:'nums',width:50},
      {Header:'아이디',accessor:'adm_id',width:120},
      {Header:'부운영자명',accessor:'adm_name',width:150},
      {Header:'고유번호',accessor:'adm_idx',width:20}
  ];
  const [varColumnLists,setColumnLists] = useState([]);

  //부운영자 목록
  const [varSubAdminLists,setSubAdminLists] = useState([]);

  //부운영자 목록 읽어오기
  const GetSubAdminList = async () => {
    console.log('load...');
    await axios.post(`${process.env.REACT_APP_HOST}/_get_subadmin_list`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let newArray = [];
        const pmax = datas.results?.length;
        if(pmax > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['adm_id'] = lineObj.adm_id;
            newData['adm_name'] = lineObj.adm_name;
            newData['adm_idx'] = lineObj.adm_idx;
            newArray.push(newData);
          }
        }
        //console.log(newArray);
        setSubAdminLists(newArray);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'ENVIRONMENT',item:'SubAdminInformation'});
    console.log(varAdminMenus);
    GetSubAdminList();
    setColumnLists(columnList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //부운영자 상세보기
  //등록/편집 보기
  const [varSubAdminIndex,setSubAdminIndex] = useState(0);
  const [varShowDetail,setShowDetail] = useState(false);
  const onShowSubAdminHandler = (e,adm_idx) => {
    setSubAdminIndex(adm_idx);
    setShowDetail(true);
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={"부운영자 관리"} varDirection={'설정'}/>
      <div className="admin-content">
        <div className="main-box" style={{marginTop:"30px"}}>
          <div className="btn-right">
            <button onClick={e=>onShowSubAdminHandler(e,0)} className="btn-danger">부운영자 등록</button>
          </div>
          {varSubAdminLists.length===0?null:
            <SubAdminSearchResult varColumnLists={varColumnLists} varSubAdminLists={varSubAdminLists}
                  GetSubAdminList={GetSubAdminList} onShowSubAdminHandler={onShowSubAdminHandler}/>}
        </div>
      </div>
      <SubAdminDetail varShowDetail={varShowDetail} setShowDetail={setShowDetail} varSubAdminIndex={varSubAdminIndex} GetSubAdminList={GetSubAdminList} />
    </div>
  );
}
export default SubAdminInformation;